import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-brand">🎣 Unofficial Fishing Derby</p>
        <nav className="footer-links" aria-label="Footer navigation">
          <Link to="/">Home</Link>
          <Link to="/register">Profile & Sign In</Link>
          <Link to="/submit">Submit Catch</Link>
          <Link to="/leaderboard">Leaderboard</Link>
          <Link to="/rules">Rules & Schedule</Link>
        </nav>
        <p className="footer-copy">
          © {year} Unofficial Fishing Derby. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
